module.exports = __webpack_public_path__ + "img/B.fecbf684.jpg";